'use client'

import { useEffect, useState } from 'react'

export interface FeatureAccess {
  testExams: boolean
  learningMode: boolean
  games: boolean
  questions: boolean
}

interface UseFeatureAccessResult {
  featureAccess: FeatureAccess | null
  isLoading: boolean
}

const DEFAULT_ACCESS: FeatureAccess = {
  testExams: false,
  learningMode: false,
  games: false,
  questions: false,
}

export function useFeatureAccess(): UseFeatureAccessResult {
  const [featureAccess, setFeatureAccess] = useState<FeatureAccess | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    async function fetchAccess() {
      try {
        const res = await fetch('/api/user/feature-access')
        if (!res.ok) {
          if (!cancelled) setFeatureAccess(DEFAULT_ACCESS)
          return
        }
        const data: FeatureAccess = await res.json()
        if (!cancelled) setFeatureAccess(data)
      } catch {
        if (!cancelled) setFeatureAccess(DEFAULT_ACCESS)
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }

    fetchAccess()
    return () => {
      cancelled = true
    }
  }, [])

  return { featureAccess, isLoading }
}
